import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/userService/user.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})

export class ProfileComponent implements OnInit {
  userInformation: any = {}
  userid: any;
  profileImgUrl: string;
  permission: any;
  userRId: any;
  Mpermission: any;

  constructor(
    private UserService: UserService,
    private toastrService: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    let Mpermi = JSON.parse(localStorage.getItem('ModulePermission'));
    this.Mpermission = this.UserService.decryptData(Mpermi);
    let permi = JSON.parse(localStorage.getItem('Permission'));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem('roleId');
    this.userRId = this.UserService.decryptData(userrId);
    let id = localStorage.getItem('userId');
    this.userid = this.UserService.decryptData(id);
    let data = {
      "UserId": this.userid
    }
    this.spinner.show();

    this.UserService.GetUserOwnDetail(data).subscribe(res => {
      if (res['result'] == 'success') {
        this.spinner.hide();
        this.userInformation = res['Data'];
        if (res['Data']['ImagePath'] == '' || res['Data']['ImagePath'] == null || res['Data']['ImagePath'] == 'Uploads/User_Doc/') {
          this.profileImgUrl = environment.default_img;
        } else {
          this.profileImgUrl = environment.app_path + res['Data']['ImagePath'];
        }
      }
    })
  }
}
